import Swiper from 'swiper/bundle';

const initAllSwiper = () => {

	// init swiper Container
	const swiperCarousel = new Swiper('.js--carousel', {
		// Optional parameters
		spaceBetween: 30,
		slidesPerView: 1,
		slidesPerGroup: 1,
		loop: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			type: "fraction",
		},
		breakpoints: {
			// when window width is >= 640px
			530: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
			1100: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
		}
	});

	// init swiper Container
	const swiperSlider = new Swiper('.js--slider', {
		// Optional parameters
		slidesPerView: 1,
		slidesPerGroup: 1,
		loop: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		}
	});

}

export default initAllSwiper;
